<template>
	<section>
		<div class="news-overview news-box">
			<h4 class="active-title">
				{{ $t('enterprise.news') }}
				<span class="more position-abs" @click="goToNewsList" v-if="newsList.length">
					{{ $t('enterprise.see-more') }}<i class="iconfont iconjiantouyou"></i
				></span>
			</h4>
		</div>
		<div class="news-list" v-if="newsList.length != 0">
			<CCardSymbol
				v-for="(item, index) in newsList"
				:key="index"
				:item="item"
				:formatter="
					() => ({
						subject: item.title,
						imageUrl: item.image,
						date: formatYear(item.time)
					})
				"
				:border="false"
				moduleType="news"
				@click="jumpToNews(item)"
			></CCardSymbol>
		</div>
		<template v-else>
			<div class="tab-bar__null">
				<CFullEmpty />
			</div>
		</template>
	</section>
</template>

<script>
import CCardSymbol from '@/view/enterprise/components/c-card-symbol.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import { dateFormat } from '@/utils/api';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export default {
	components: {
		CCardSymbol,
		CFullEmpty
	},
	props: {
		newsList: {
			type: Array,
			default: () => [] // 默认值为一个空数组
		}
	},
	data() {
		return {};
	},
	methods: {
		formatYear(value) {
			return dateFormat(new Date(Number(value)), 'yyyy-MM-dd');
		}
	},
	setup() {
		const { goToModule } = useNavigation();
		const goToNewsList = () => {
			goToModule('news');
		};

		const { viewModule } = useModuleNavigation();
		const jumpToNews = item => {
			viewModule('news', item);
		};

		return {
			goToNewsList,
			jumpToNews
		};
	}
};
</script>

<style lang="less" scoped>
.news-overview {
	.active-title {
		position: relative;
		padding: 0.2rem 0 0.1rem 0;
		font-weight: 500;
		font-size: 0.15rem;
		line-height: 0.21rem;
		color: #333;
		.position-abs {
			right: 0;
			top: 0.21rem;
		}
	}

	.position-abs {
		position: absolute;
		top: 0.15rem;
		right: 0.12rem;
	}

	.more {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: 0.11rem;
		line-height: 0.15rem;
		color: #666;
		.iconjiantouyou {
			font-size: 0.12rem;
		}
	}
}
.news-box {
	padding: 0;
	// margin-bottom: 0.1rem;
	border-radius: 0;
	.active-title {
		padding-bottom: 0;
	}

	.more-shareholder {
		display: flex;
		align-items: center;
		font-size: 12px;
		margin-top: 10px;
		&::before {
			content: '';
			width: 0.1rem;
			height: 0.1rem;
			border-radius: 0.02rem;
			background: var(--ir-theme-color);
			margin-right: 0.03rem;
		}
	}
}

.tab-bar__null {
	height: 1.77rem;
}
.news-list {
	margin-top: 0.2rem;
}
</style>
